import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { IOption } from "ng-select";
import { NgForm } from "@angular/forms";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { HelperService } from "../../services/helper.service";

import { AssessmentMasterService } from "../../services/assesment-master.service";
import Swal from 'sweetalert2/dist/sweetalert2.js'; 
@Component({
  selector: "app-assessment-type",
  templateUrl: "./assessment-master-modal.component.html",
  styleUrls: ["./assessment-master-modal.component.scss"],
  providers: [AssessmentMasterService],
})
export class AssessmentMasterModalComponent implements OnInit {
  @Output() public AssessmentMasterReload: EventEmitter<any> =
    new EventEmitter<any>();

  public masterData: any = {};
  formData = {
    code: "",
    description: "",
    note: "",
    pass_marks: "",
    type_id: "",
    no_of_quiz:"",
    active: 0,
  };

  isEdit: number;
  @ViewChild("form") form: NgForm;
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = +this.helperService.getSelectedCompanyId();
  // languageSystemID = +this.helperService.getAvailableLang();
  languageSystemID = 1;

  activeStatus = [
    { value: 0, label: "No" },
    // { value: 1, label: "Yes" },
  ];

  TypeStatus = [
    { value: 1, label: "Standard" },
    // { value: 2, label: "Detail" },
  ];

  quizType = [
    { value: 1, label: "MCQ Only" },
    { value: 2, label: "Written Only" },
    { value: 3, label: "MCQ & Written" },
  ];

  codeGenerated = "";

  constructor(
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private helperService: HelperService,
    private assessmentMasterService: AssessmentMasterService
  ) {}

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  generateRandomDocNumber() {
    const randomNumber = Math.floor(Math.random() * 99999) + 1;
    this.formData.code = `AM/${randomNumber.toString().padStart(6, "0")}`;
    this.codeGenerated = this.formData.code;
  }

  ngOnInit() {
    this.generateRandomDocNumber();
  }

  addAssessmentMaster(formData: any) {
    const activeValue = formData.active === undefined ? 0 : formData.active;
    const requestData = {
      code: this.codeGenerated,
      description: formData.description,
      note: formData.note,
      pass_marks: formData.pass_marks,
      type_id: formData.type_id,
      quiz_type: formData.quiz_type,
      active: activeValue,
      no_of_quiz:formData.no_of_quiz,
      company_id: this.companySystemID,
      language_id: this.languageSystemID,
    };
    let that = this;

    // if(formData.no_of_quiz ==' ' || formData.no_of_quiz == null ){
    //   Swal.fire({  
      
    //     title: 'Error',  
    //     text: 'No Of Question is required.',  
         
    //   })  
    // }
    // else{



    that.masterData.companySystemID = that.companySystemID;
    that.assessmentMasterService
      .createAssessmentMaster()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          console.log(resp);
          that.masterData = {};
          that.successMsg = "";
          that.successMsg = "Successfully added assessment master";
          that.showSuccessHtml();
          that.closeModalAfterCreate();
          this.AssessmentMasterReload.emit();
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(
              error.data.message
            );
            that.showErrorHtml();
            this.AssessmentMasterReload.emit();
          }
        }
      );
    this.AssessmentMasterReload.emit();
  // }
}
}



// WEBPACK FOOTER //
// /app/src/app/competancy/assessment-master-modal/assessment-master-modal.component.ts